import BaseLayout from '@/components/layouts/BaseLayout'
import LayoutBlank from '@/components/layouts/LayoutBlank'
import Main from '../pages/Alarm/Main'
// import LayoutWithoutNavFooter from '@/components/layouts/LayoutWithoutNavFooter'

export default [{
  path: '/alarm',
  name: 'alarm',
  navbar: true,
  title: 'alarms',
  icon: 'fas fa-bell',
  component: BaseLayout,
  meta: { perm: 'Navbar.Alarm' },
  children: [
    {
      path: '',
      title: 'alarm',
      icon: 'fas fa-bell',
      component: Main,
      name: 'alarm',
      hide: true,
      meta: { perm: 'Navbar.Alarm' }
    },
    {
      path: '',
      title: 'Alarm',
      icon: 'fas fa-bell',
      name: 'alarm',
      component: LayoutBlank,
      meta: { perm: 'Navbar.Alarm' },
      children: [
        {
          path: 'new-alarm',
          title: 'new_alarm',
          icon: 'fas fa-plus',
          name: 'new_alarm',
          component: () => import('@/pages/Alarm/NewAlarm'),
          meta: { perm: 'Pages.NewAlarm' }
        },
        {
          path: 'edit-alarm',
          title: 'new_alarm',
          icon: 'fas fa-plus',
          name: 'edit_alarm',
          hide: true,
          component: () => import('@/pages/Alarm/EditAlarm'),
          meta: { perm: 'Pages.EditAlarm' }
        },
        {
          path: 'alarm-list',
          title: 'alarm_list',
          icon: 'fas fa-list',
          name: 'alarm_list',
          component: () => import('@/pages/Alarm/Alarms'),
          meta: { perm: 'Pages.Alarms' }
        },
        {
          path: 'alarm-tracking',
          title: 'alarm_tracking_screen',
          icon: 'ion ion-md-alarm',
          name: 'alarm_tracking',
          hide: true,
          meta: { perm: 'Pages.AlarmReports' },
          component: () => import('@/pages/Alarm/AlarmTracking')
        },
        {
          path: 'alarm-reports',
          title: 'reports',
          icon: 'fas fa-folder-open',
          name: 'alarm_reports',
          hide: true,
          component: () => import('@/pages/Alarm/AlarmReports'),
          meta: { perm: 'Pages.AlarmReports' }
        }
      ]
    },
    {
      path: '',
      navbar: false,
      title: 'alarm_tracking',
      icon: 'ion ion-md-alarm',
      meta: { perm: 'Pages.AlarmReports' },
      children: [{
        path: 'alarm-tracking',
        title: 'alarm_tracking_screen',
        icon: 'ion ion-md-alarm',
        name: 'alarm_tracking',
        meta: { perm: 'Pages.AlarmReports' },
        component: () => import('@/pages/Alarm/AlarmTracking')
      },
      {
        path: 'alarm-reports',
        title: 'reports',
        icon: 'fas fa-folder-open',
        name: 'alarm_reports',
        component: () => import('@/pages/Alarm/AlarmReports'),
        meta: { perm: 'Pages.AlarmReports' }
      }
      ]
    }
  ]
}
]
